import { render, staticRenderFns } from "./reporta4.vue?vue&type=template&id=b3b32cca&"
import script from "./reporta4.vue?vue&type=script&lang=js&"
export * from "./reporta4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports